module.exports = __webpack_public_path__ + "img/Tonearm Black.637438a5.png";